export default __webpack_public_path__ + "static/media/psactions_bannergeneration.2ee761a7.jpg";